"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const zodMMDashDDString = zod_1.z
    .string()
    .regex(/^(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/, 'Must be in MM-DD format (e.g. 02-14)')
    .nullable();
const zodDayOfWeek = zod_1.z.enum(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']);
const newReportSchema = zod_1.z.object({
    dayOfWeek: zodDayOfWeek,
    name: zod_1.z.string().max(150),
    notifyOwnerByEmail: zod_1.z.boolean(),
    propertyIds: zod_1.z.array(zod_1.z.number()).nonempty().nullable(),
    contacts: zod_1.z.array(zod_1.z.object({ contactId: zod_1.z.string() })).nullable(),
    groups: zod_1.z.array(zod_1.z.object({ groupId: zod_1.z.number() })).nullable(),
    startDate: zodMMDashDDString,
    endDate: zodMMDashDDString,
    rules: zod_1.z.array(zod_1.z.object({
        insectId: zod_1.z.string(),
        startDate: zodMMDashDDString,
        endDate: zodMMDashDDString,
    })),
});
exports.requestSchema = zod_1.z
    .object({
    legacyWeeklyTrapCatchesReportsToUpdate: zod_1.z.record(zod_1.z.string(), newReportSchema).optional(),
    legacyWeeklyTrapCatchesReportsToDelete: zod_1.z.array(zod_1.z.number()).optional(),
    legacyWeeklyTrapCatchesReportsToCreate: zod_1.z.array(newReportSchema).optional(),
})
    .refine((args) => !!Object.keys(args).length, {
    message: 'Request object must contain at least one argument',
});
exports.path = '/legacy-weekly-trap-catches-reports-management';
//# sourceMappingURL=index.js.map